// Loader.js

import React from "react";
import "./style.css";
const GreenThemeLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader-green"></div>
      <div className="loading-text">Loading...</div>
    </div>
  );
};

export default GreenThemeLoader;
